class ProductGallery extends HTMLElement {
  constructor () {
    super()
    this.swiper = null
  }

  connectedCallback () {
    requestAnimationFrame(() => {
      const swiperEl = this.querySelector('.swiper')
      const paginationEl = this.querySelector('.swiper-pagination')

      if (swiperEl) {
        this.swiper = new Swiper(swiperEl, {
          loop: true,
          pagination: {
            el: paginationEl,
          },
          breakpoints: {
            767: {
              enabled: false,
            },
          },
        })
      }
    })
  }
}

customElements.define('product-gallery', ProductGallery)

class ProductGridGallery extends HTMLElement {
  constructor () {
    super()
    this.swiper = null
    this.observer = null
    this.autoScrollInterval = null
  }

  connectedCallback () {
    const initSwiper = () => {
      const swiperEl = this.querySelector('.swiper')
      if (!swiperEl) return

      const paginationEl = swiperEl.querySelector('.swiper-pagination')
      if (!paginationEl) return

      if (this.swiper) {
        this.swiper.destroy()
      }

      this.swiper = new Swiper(swiperEl, {
        loop: true,
        pagination: { el: paginationEl }
      })

      // --- AUTOSCROLL ON HOVER ---
      const startAutoScroll = () => {
        this.stopAutoScroll()

        // Instantly go to next slide on hover
        this.swiper.slideNext()

        // Continue sliding every 1.5 sec
        this.autoScrollInterval = setInterval(() => {
          this.swiper.slideNext()
        }, 1500)
      }

      this.stopAutoScroll = () => {
        if (this.autoScrollInterval) {
          clearInterval(this.autoScrollInterval)
          this.autoScrollInterval = null
        }
      }

      this.addEventListener('mouseenter', startAutoScroll)

      this.addEventListener('mouseleave', () => {
        this.stopAutoScroll()
        this.swiper.slideToLoop(0) // reset to first slide
      })
      // --------------------------------

      // Stop observing once initialized
      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }
    }

    // Observe children until Swiper markup appears
    this.observer = new MutationObserver(initSwiper)
    this.observer.observe(this, { childList: true, subtree: true })

    initSwiper()
  }

  disconnectedCallback () {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
    if (this.swiper) {
      this.swiper.destroy()
      this.swiper = null
    }
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval)
    }
  }
}

customElements.define('product-grid-gallery', ProductGridGallery)
